import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CalendarDays, Users, BarChart3, LogOut, Euro, IdCard, Ticket } from "lucide-react";

const links = [
  { to: "/", label: "Planning", icon: CalendarDays, testid: "nav-item-planning", end: true },
  { to: "/intermittents", label: "Régisseurs", icon: Users, testid: "nav-item-intermittents" },
  { to: "/staff", label: "Intermittents", icon: IdCard, testid: "nav-item-staff" },
  { to: "/ouvreuses", label: "Ouvreuses", icon: Ticket, testid: "nav-item-ouvreuses" },
  { to: "/stats", label: "Statistiques", icon: BarChart3, testid: "nav-item-stats" },
  { to: "/salaires", label: "Salaires", icon: Euro, testid: "nav-item-salaires" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-md">
        <div className="mx-auto max-w-[1600px] px-4 sm:px-6 flex h-16 items-center gap-6">
          <div className="flex items-center gap-3 shrink-0">
            <img src="/logo.svg" alt="Les Derniers Couchés" className="h-9 w-9" />
            <div className="hidden sm:block leading-tight">
              <div className="font-display font-bold text-sm text-foreground tracking-tight">
                LES DERNIERS COUCHÉS
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-primary/80">
                Gestion des concerts
              </div>
            </div>
          </div>

          <nav className="flex items-center gap-1 flex-1">
            {links.map(({ to, label, icon: Icon, testid, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                data-testid={testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary/15 text-primary"
                      : "text-muted-foreground hover:text-foreground hover:bg-secondary"
                  }`
                }
              >
                <Icon className="h-4 w-4" />
                <span className="hidden md:inline">{label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3 shrink-0">
            <span className="hidden lg:block text-xs text-muted-foreground" data-testid="current-user-email">
              {user?.email}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              data-testid="logout-button"
              className="text-muted-foreground hover:text-destructive"
            >
              <LogOut className="h-4 w-4 md:mr-2" />
              <span className="hidden md:inline">Déconnexion</span>
            </Button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[1600px] px-4 sm:px-6 py-6">{children}</main>
    </div>
  );
}
